import React, {useEffect, useState} from "react";
import {Row} from "reactstrap";
import {Divider} from "@mui/material";
import Button from "../../base/button/button";
import Dialog from "../../base/dialog";

const SimpleMoreDetailsDialog = ({open, setOpen, details, title}) => {
    const [prop, setProp] = useState({title: title, details: details});

    /**
     * With each change in the details and title, set the values of [prop] in the inner state
     */
    useEffect(() => {
        setProp({
            title: title,
            details: details
        });
    }, [details, title])

    return (
        <Dialog
            open={open}
            setOpen={setOpen}
            maxWidth={'sm'}
        >
            <Row className='no-gutters justify-content-center align-items-start w-100'>
                <Row xs={12} className='no-gutters justify-content-center  w-100'>
                    <p className={`text-lg text-color-1 my-3 font-weight-semi-bold text-center`}>
                        {prop.title}
                    </p>
                </Row>
                <Divider className='divider'/>
                <div className='my-3 w-100'/>
                <div className='mx-4 w-100 row no-gutters align-items-center justify-content-center'>
                    <p className={'text-md'}>
                        {prop.details}
                    </p>
                </div>
                <div className='my-3 w-100'/>
                <Divider className='divider'/>
                <Row className='no-gutters justify-content-between align-items-start w-100'>
                    <Button
                        disabled={!open}
                        variant={'dialog'}
                        color={'primary'}
                        onClick={() => setOpen(false)}
                        borderRadius={'0 8px 0 8px'}
                    >
                        Close
                    </Button>
                    <div/>
                </Row>
            </Row>
        </Dialog>
    );
}

export default SimpleMoreDetailsDialog;
